/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createIsNotCompatibleHelper } from "@todesktop/client-util/checkIfCompatibleWithBackend.js";
import { invoke } from "./invoke.js";
import { createOnAndOffNamespaceListeners, } from "./utils.js";
/**
 * Methods for interacting with todesktop updater
 *
 * @remarks
 * This package exposes a number of methods that allow you to access properties and interact with methods on todesktop updater.
 *
 * @experimental
 * @public
 * @packageDocumentation
 */
const isNotCompatible = createIsNotCompatibleHelper("todesktopUpdater", "4.49.0");
/**
 * Checks for update and downloads if available.
 * @public
 */
export async function checkForUpdates(options = {}) {
    if (isNotCompatible("checkForUpdates"))
        return;
    return invoke({
        namespace: "todesktopUpdater",
        // @ts-expect-error - expect an error because we had to manually type the return value to avoid the following: The inferred type of 'checkForUpdates' cannot be named without a reference to '@todesktop/client-util/node_modules/@todesktop/client-todesktop-runtime-types/dist/AutoUpdater.js'. This is likely not portable. A type annotation is necessary.
        method: "checkForUpdates",
        args: [options],
    });
}
/**
 * Restarts the app and installs the update after it has been downloaded. It should only be called after update-downloaded has been emitted.
 *
 * @param options - isSilent: *windows-only* Runs the installer in silent mode. Defaults to `false`; isForceRunAfter: Run the app after finish even on silent install. Not applicable for macOS. Ignored if `isSilent` is set to `false`.
 * @public
 */
export async function restartAndInstall(options = {}) {
    if (isNotCompatible("restartAndInstall"))
        return;
    return invoke({
        namespace: "todesktopUpdater",
        method: "restartAndInstall",
        args: [options],
    });
}
const listeners = createOnAndOffNamespaceListeners("todesktopUpdater");
/**
 * Subcribes to an todesktopUpdater event.
 *
 * @param eventName - The event name to subscribe to.
 * @param callback - The callback function to execute when the event occurs.
 * @returns unsubscribe callback.
 * @public
 */
export const on = listeners.on;
/**
 * Unsubscribes all todesktopUpdater listeners from a target event.
 *
 * @param options - eventName: The event name to unsubscribe from;
 * @public
 */
export const removeAllListeners = listeners.removeAllListeners;
